import React from 'react';

const LoginIllustration: React.FC = () => {
  return (
    <svg
      viewBox="0 0 600 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto"
    >
      {/* Background circles */}
      <circle cx="450" cy="100" r="100" fill="#EEF2FF" opacity="0.6" />
      <circle cx="100" cy="500" r="80" fill="#FED7AA" opacity="0.5" />
      <circle cx="500" cy="450" r="60" fill="#DBEAFE" opacity="0.4" />

      {/* Main character - Person with laptop */}
      <g transform="translate(250, 280)">
        {/* Desk */}
        <rect x="-120" y="80" width="240" height="12" rx="6" fill="#6366F1" />
        <rect x="-110" y="92" width="10" height="80" rx="2" fill="#4F46E5" />
        <rect x="100" y="92" width="10" height="80" rx="2" fill="#4F46E5" />

        {/* Laptop */}
        <g transform="translate(0, 40)">
          {/* Laptop base */}
          <ellipse cx="0" cy="45" rx="65" ry="8" fill="#D1D5DB" opacity="0.4" />
          <rect x="-60" y="30" width="120" height="15" rx="2" fill="#374151" />

          {/* Laptop screen */}
          <rect x="-55" y="-40" width="110" height="70" rx="4" fill="#1F2937" />
          <rect x="-50" y="-35" width="100" height="60" rx="2" fill="#4F46E5" />

          {/* Screen content - Login form preview */}
          <rect x="-40" y="-25" width="80" height="6" rx="3" fill="#818CF8" />
          <rect x="-40" y="-15" width="80" height="6" rx="3" fill="#A5B4FC" />
          <rect x="-40" y="-5" width="50" height="6" rx="3" fill="#C7D2FE" />

          {/* Glow effect */}
          <rect x="-55" y="-40" width="110" height="70" rx="4" fill="url(#screenGlow)" opacity="0.3" />
        </g>

        {/* Person's body */}
        <ellipse cx="0" cy="85" rx="40" ry="12" fill="#D1D5DB" opacity="0.3" />
        <path d="M -25 20 Q -28 50 -35 80 L -15 80 L -8 40 L 0 40 L 8 40 L 15 80 L 35 80 Q 28 50 25 20 Z" fill="#4F46E5" />

        {/* Arms */}
        <path d="M -25 30 Q -50 35 -55 50 L -45 55 Q -40 45 -20 38 Z" fill="#6366F1" />
        <path d="M 25 30 Q 50 35 55 50 L 45 55 Q 40 45 20 38 Z" fill="#6366F1" />

        {/* Head */}
        <circle cx="0" cy="0" r="20" fill="#FCD34D" />

        {/* Hair */}
        <path d="M -18 -8 Q -20 -18 -12 -22 Q 0 -24 12 -22 Q 20 -18 18 -8 Z" fill="#1F2937" />

        {/* Face features */}
        <circle cx="-7" cy="-2" r="2" fill="#1F2937" />
        <circle cx="7" cy="-2" r="2" fill="#1F2937" />
        <path d="M -6 6 Q 0 9 6 6" stroke="#1F2937" strokeWidth="1.5" fill="none" strokeLinecap="round" />

        {/* Neck */}
        <rect x="-6" y="18" width="12" height="8" fill="#FCD34D" />
      </g>

      {/* Floating UI elements */}
      {/* Success checkmark */}
      <g transform="translate(120, 150)">
        <circle cx="0" cy="0" r="35" fill="#10B981" opacity="0.2" />
        <circle cx="0" cy="0" r="25" fill="#10B981" />
        <path d="M -8 0 L -3 8 L 10 -8" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      {/* Security shield */}
      <g transform="translate(480, 200)">
        <ellipse cx="0" cy="35" rx="20" ry="4" fill="#000" opacity="0.1" />
        <path d="M 0 -25 L 20 -15 L 20 5 Q 20 25 0 30 Q -20 25 -20 5 L -20 -15 Z" fill="#6366F1" />
        <path d="M 0 -20 L 15 -12 L 15 5 Q 15 20 0 24 Q -15 20 -15 5 L -15 -12 Z" fill="#818CF8" />
        <path d="M -6 2 L -2 8 L 8 -6" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      {/* Lock icon */}
      <g transform="translate(420, 380)">
        <circle cx="0" cy="25" r="15" fill="#000" opacity="0.1" />
        <rect x="-15" y="5" width="30" height="25" rx="4" fill="#F59E0B" />
        <rect x="-12" y="8" width="24" height="19" rx="2" fill="#FCD34D" />
        <rect x="-3" y="13" width="6" height="8" rx="1" fill="#F59E0B" />
        <path d="M -10 5 L -10 -5 Q -10 -15 0 -15 Q 10 -15 10 -5 L 10 5" stroke="#F59E0B" strokeWidth="4" fill="none" strokeLinecap="round" />
        <path d="M -8 5 L -8 -5 Q -8 -12 0 -12 Q 8 -12 8 -5 L 8 5" stroke="#FCD34D" strokeWidth="3" fill="none" strokeLinecap="round" />
      </g>

      {/* Data/Analytics cards floating */}
      <g transform="translate(100, 380)">
        <rect x="0" y="0" width="80" height="50" rx="6" fill="white" stroke="#E5E7EB" strokeWidth="2" />
        <rect x="8" y="8" width="24" height="4" rx="2" fill="#6366F1" />
        <rect x="8" y="18" width="64" height="3" rx="1.5" fill="#D1D5DB" />
        <rect x="8" y="25" width="50" height="3" rx="1.5" fill="#D1D5DB" />
        <rect x="8" y="35" width="40" height="8" rx="2" fill="#4F46E5" />
      </g>

      {/* Clock/Time icon */}
      <g transform="translate(480, 520)">
        <circle cx="0" cy="0" r="25" fill="#EEF2FF" />
        <circle cx="0" cy="0" r="20" fill="#6366F1" />
        <circle cx="0" cy="0" r="16" fill="white" />
        <line x1="0" y1="0" x2="0" y2="-10" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" />
        <line x1="0" y1="0" x2="7" y2="0" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" />
      </g>

      {/* Decorative code brackets */}
      <g transform="translate(150, 500)" opacity="0.4">
        <text x="0" y="0" fill="#6366F1" fontSize="40" fontFamily="monospace" fontWeight="bold">{'{ }'}</text>
      </g>

      {/* Gradient definitions */}
      <defs>
        <linearGradient id="screenGlow" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#A5B4FC" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#6366F1" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      {/* Floating particles */}
      <circle cx="180" cy="120" r="3" fill="#6366F1" opacity="0.4">
        <animate attributeName="cy" values="120;110;120" dur="3s" repeatCount="indefinite" />
      </circle>
      <circle cx="420" cy="140" r="4" fill="#F59E0B" opacity="0.4">
        <animate attributeName="cy" values="140;130;140" dur="4s" repeatCount="indefinite" />
      </circle>
      <circle cx="520" cy="300" r="3" fill="#10B981" opacity="0.4">
        <animate attributeName="cy" values="300;290;300" dur="3.5s" repeatCount="indefinite" />
      </circle>

      {/* Bottom wave decoration */}
      <path d="M 0 570 Q 150 550 300 570 T 600 570 L 600 600 L 0 600 Z" fill="#EEF2FF" opacity="0.5" />
    </svg>
  );
};

export default LoginIllustration;
